.ho{border-radius:0.375rem;}